var map = {
	"./random1.jpg": 2666,
	"./random2.jpg": 2186,
	"./random3.jpg": 3239,
	"./random4.jpg": 9866,
	"./random5.jpg": 808,
	"./random6.jpg": 4510,
	"./random7.jpg": 2881,
	"./random8.jpg": 1056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;